<template>
  <button :style="{'border-radius': rad} ">
      <span class="material-icons">
        {{ btnIcon }}
      </span>
  </button>
</template>

<script>
export default {
name: "MyButton",
  props:['btnIcon', 'rad']
}
</script>

<style scoped>
button{
  background-color: var(--bg);
  color: var(--color);
  box-shadow: var(--shadow);
  border: none;
  width: 40px;
  height: 40px;
  margin: 20px;
  outline: none;
  border-radius: 50%;
  transition: all .3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
}

button:active{
  box-shadow:none;
}
</style>